import styles from "../css/StoryView.module.css"
import { Dialog, DialogContent, IconButton, Snackbar, TextField, Alert } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useRef, useState } from "react";
import SendIcon from '@mui/icons-material/Send';
import Wait from "./Wait";
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

import miAxios from "../api/axios";
import { useAuth } from "../hooks/AuthProvider";
import { useNavigate } from "react-router-dom";

export default function StoryView(props) {
    const videoRef = useRef(null)
    const [progress, setProgress] = useState(0)
    const [procesando, setProcesando] = useState(true)
    const [comentario, setComentario] = useState("")
    const [mensaje, setMensaje] = useState("")
    const [openInfo, setOpenInfo] = useState({ open: false, id: 0 })
    const [reproduciendo, setReproduciendo] = useState(false)
    const [isMuted, setIsMuted] = useState(true);

    const user = useAuth()
    const axios = miAxios(user.handleLogout)
    const navigate = useNavigate()

    useEffect(() => {
        if (props.url.length != 0) {
            setProcesando(true)
        }
    }, [props.url])



    const handleInicioVideo = () => {
        setProcesando(false)
    }

    const handleCloseMensaje = () => {
        setMensaje("")
    }



    const handleReproduciendo = () => {
        setReproduciendo(true)
    }

    const handleTogglePausa = () => {
        if (reproduciendo) {
            videoRef.current.pause()
            setReproduciendo(false)
        } else {
            videoRef.current.play()
        }
    }

    const activarSonido = () => {
        const video = videoRef.current;
        if (video) {
            video.muted = !video.muted;
            setIsMuted(video.muted);
        }
    }

    return <div className={styles.cuerpo}>
        <Wait procesando={procesando} />
        <Snackbar
            open={mensaje.length == 0 ? false : true}
            sx={{ zIndex: 500000 }}
            autoHideDuration={1000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseMensaje}
        >
            <Alert severity="info" onClose={handleCloseMensaje} variant="filled">{mensaje}</Alert>
        </Snackbar>
        <div className={styles.cuerpo}>
            <div className={styles.videoContainer}>
                <video
                    className={styles.videoElement}
                    ref={videoRef}
                    src={props.url}
                    controls={false}
                    autoPlay
                    playsInline
                    muted
                    onCanPlayThrough={handleInicioVideo}
                    onEnded={() => { props.cerrar() }}
                    onPlay={() => { handleReproduciendo() }}
                    onClick={handleTogglePausa}
                />
            </div>

        </div>
        {isMuted && (<div className={styles.quitar_mute}>
            <div className={styles.quitar_mute_bot}>
                <IconButton onClick={activarSonido}>
                    <VolumeOffIcon />
                </IconButton>
            </div>
            <div className={styles.quitar_mute_text}>
                Activar Sonido
            </div>
        </div>)}
    </div>



}